export const DATE_FORMATS = {
    s: 'DD.MM.YYYY HH:mm:ss',
    m: 'DD.MM.YYYY HH:mm',
    H: 'DD.MM.YYYY HH',
    D: 'DD.MM.YYYY',
    M: 'MM.YYYY',
    W: 'YYYY-wo',
    Q: 'YYYY-[Q]Q',
    Y: 'YYYY',
    HH: 'HH',
    Hm: 'HH:mm',
    Hms: 'HH:mm:ss',
};
export const NUMBER_COMPACT = [
    {
        compact: 'тыс.',
        conversion: 1000,
    },
    {
        compact: 'млн',
        conversion: 1000000,
    },
    {
        compact: 'млрд',
        conversion: 1000000000,
    },
    {
        compact: 'трлн',
        conversion: 1000000000000,
    },
];
